import grapesjsPresetNewsletter from "grapesjs-preset-newsletter";
import MainBlocks from "@/libraries/grapesjs/main";
// import GrapesJsCustomCode from "grapesjs-custom-code";
export default {
  plugins: [
    grapesjsPresetNewsletter,
    MainBlocks,
    // GrapesJsCustomCode
  ]
}
